<app-about-us class="card-wide" [matterId]="id"></app-about-us>
<app-inbox-list [matterId]="id"></app-inbox-list>
<app-activity-list [matterId]="id"></app-activity-list>
<app-document-list [matterId]="id"></app-document-list>
